import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '中间件实例',
    type: 'MID_MIDINS',
}
